export const GET_TITLES = "GET_TITLES"
export const GET_TITLES_FAIL = "GET_TITLES_FAIL"
export const GET_TITLES_SUCCESS = "GET_TITLES_SUCCESS"

export const ADD_NEW_TITLE = "ADD_NEW_TITLE"
export const ADD_TITLE_SUCCESS = "ADD_TITLE_SUCCESS"
export const ADD_TITLE_FAIL = "ADD_TITLE_FAIL"

export const UPDATE_TITLE = "UPDATE_TITLE"
export const UPDATE_TITLE_SUCCESS = "UPDATE_TITLE_SUCCESS"
export const UPDATE_TITLE_FAIL = "UPDATE_TITLE_FAIL"

export const DELETE_TITLE = "DELETE_TITLE"
export const DELETE_TITLE_SUCCESS = "DELETE_TITLE_SUCCESS"
export const DELETE_TITLE_FAIL = "DELETE_TITLE_FAIL"





